// frontend/src/hooks/useWhatsNew.js
// CODEX_PROMPT_88 : hook de lecture du contenu dynamique "Quoi de neuf".
// Meme mecanique de cache module-level 5 min que useMonthlyChallenge : pas de
// dependance externe, partage entre instances pendant le cycle de vie de la page.
import { useState, useEffect } from 'react';
import { fetchWhatsNewContent } from '../services/whatsNewService';

const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

// Cache module-level. _cache === null est un etat valide (erreur reseau ->
// fallback statique) ; on distingue "jamais charge" via _cacheTs === 0.
let _cache = null;
let _cacheTs = 0;

// Helper de test : reinitialise le cache module-level entre deux tests Jest.
export function __resetWhatsNewCache() {
  _cache = null;
  _cacheTs = 0;
}

/**
 * @returns {{ content: ({settings, cards}|null), loading: boolean }}
 *   content === null => le composant utilise le fallback statique whatsNew.js.
 */
export function useWhatsNew() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      // Cache frais : ne pas refetch (y compris un cache null issu d'une erreur).
      if (_cacheTs && Date.now() - _cacheTs < CACHE_TTL_MS) {
        if (!cancelled) {
          setContent(_cache);
          setLoading(false);
        }
        return;
      }

      const result = await fetchWhatsNewContent();
      if (cancelled) return;

      _cache = result;
      _cacheTs = Date.now();
      setContent(result);
      setLoading(false);
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return { content, loading };
}
